import { request as __request } from '../core/request';
export class BackendJkUserService {
    /**
     * 根據URL取得統計相關的帳號
     * @returns any Success
     * @throws ApiError
     */
    static statsByUrl() {
        return __request({
            method: 'GET',
            path: `/api/backend/jk_user/stats_by_url`,
        });
    }
    /**
     * [BASE] Search From JKUserEntity
     * @returns any Success
     * @throws ApiError
     */
    static findAll({ where, page, }) {
        return __request({
            method: 'GET',
            path: `/api/backend/jk_user`,
            query: {
                'where': where,
                'page': page,
            },
        });
    }
    /**
     * [BASE] Add To JKUserEntity
     * @returns any Success
     * @throws ApiError
     */
    static add({ requestBody, }) {
        return __request({
            method: 'POST',
            path: `/api/backend/jk_user`,
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * [BASE] Batch Update To JKUserEntity
     * @returns void
     * @throws ApiError
     */
    static batchUpdate({ requestBody, }) {
        return __request({
            method: 'PUT',
            path: `/api/backend/jk_user`,
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * [BASE] FindOne From JKUserEntity
     * @returns any Success
     * @throws ApiError
     */
    static findOne({ id, }) {
        return __request({
            method: 'GET',
            path: `/api/backend/jk_user/${id}`,
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * [BASE] Update To JKUserEntity
     * @returns any Success
     * @throws ApiError
     */
    static update({ id, requestBody, }) {
        return __request({
            method: 'PUT',
            path: `/api/backend/jk_user/${id}`,
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * [BASE] Delete From JKUserEntity
     * @returns void
     * @throws ApiError
     */
    static delete({ id, softDelete, }) {
        return __request({
            method: 'DELETE',
            path: `/api/backend/jk_user/${id}`,
            query: {
                'softDelete': softDelete,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
